import { render } from "./RecommendComplete.vue?vue&type=template&id=167f4a4e"
import script from "./RecommendComplete.vue?vue&type=script&lang=js"
export * from "./RecommendComplete.vue?vue&type=script&lang=js"

import exportComponent from "/home/burton/workspace_skttu/skttu-vote-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__